<template>
  <div
    class="relative flex min-h-24 flex-col items-center justify-center p-4 text-center"
  >
    <IconExclamationCircleFilled
      class="mb-2 text-3xl text-error"
    />
    <p class="font-semibold">
      <slot />
    </p>
    <FormSubmitButton
      v-if="showRetry"
      type="button"
      class="mt-2"
      @click="emit('retry')"
    >
      Retry
    </FormSubmitButton>
  </div>
</template>

<script setup lang="ts">
import { IconExclamationCircleFilled } from "@/icons"

const emit = defineEmits<{
  (event: "retry"): void
}>()

const props = defineProps<{
  showRetry?: boolean
}>()
</script>
